import { useEffect, useState } from "react";
const useTimer = () => {
    const [time, setTime] = useState(0);
    const [stopped, setStopped] = useState(true);
    const stopTimer = () => {
        setStopped(true);
    };
    const startTimer = () => {
        setStopped(false);
    };
    const resetTimer = () => {
        setTime(0);
        setStopped(true);
    };
    useEffect(() => {
        let intervalId = setInterval(() => {
            if (!stopped) {
                setTime((prevTimer) => {
                    return prevTimer + 1000;
                });
            }
        }, 1000);
        if (intervalId && stopped)
            clearInterval(intervalId);
        return () => clearInterval(intervalId);
    }, [stopped]);
    const formatTime = (time) => {
        if (time < 10) {
            return `0${time}`;
        }
        return time;
    };
    const getTime = () => {
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / (60 * 1000)) % 60);
        const hours = Math.floor((time / (60 * 60 * 1000)) % 60);
        return (`${hours !== 0 ? formatTime(hours) + ":" : ""}${formatTime(minutes)}:${formatTime(seconds)}`);
    };
    return {
        time,
        setTime,
        stopped,
        stopTimer,
        startTimer,
        resetTimer,
        getTime
    };
};
export default useTimer;
